import { render, staticRenderFns } from "./addBeneficiary.vue?vue&type=template&id=2d341dae&"
import script from "./addBeneficiary.vue?vue&type=script&lang=js&"
export * from "./addBeneficiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports